import { DateHeaderColumn } from 'app/form-fields/date/register/date-header-column';
import { TableFilter } from 'app/form-fields/table/register/table-filter';

import { UserHeaderColumn } from './user-column/user-header-column';
import { FormFieldHeader } from '../../common/register/form-field-header/form-field-header';
import { FormFieldHeaderColumn } from '../../common/register/form-field-header/form-field-header-column';

export class SignonTableRegisterHeader extends FormFieldHeader {
  constructor(item) {
    super(item);

    this.columns = [
      new UserHeaderColumn({
        id: 'sitemateId',
        templateId: item.templateId,
        fieldId: item.id,
        description: 'Name',
      }),
      new FormFieldHeaderColumn({ description: 'Company' }),
      new FormFieldHeaderColumn({ description: 'Signature' }),
      new DateHeaderColumn({ id: 'date', description: 'Date' }),
      new FormFieldHeaderColumn({ description: 'Time' }),
      new FormFieldHeaderColumn({ description: 'Location' }),
    ];

    this.filter = new TableFilter(this.columns);
  }
}
